import { render, staticRenderFns } from "./MobileTop.vue?vue&type=template&id=dd163606&scoped=true"
import script from "./MobileTop.vue?vue&type=script&lang=js"
export * from "./MobileTop.vue?vue&type=script&lang=js"
import style0 from "./MobileTop.vue?vue&type=style&index=0&id=dd163606&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd163606",
  null
  
)

export default component.exports